import { DateTime } from "luxon";
import * as React from "react";
import { FormattedMessage, FormattedRelativeTime } from "react-intl";
import { StampContext } from "tp/shared/timeclock/messages";
import { ExistingStamp, StampDirection, AuthenticatedPerson, StampCostDivision, Task } from "tp/shared/timeclock/models";
import { Messages } from "../../messages";
import { getDaysAgoValue } from "tp/shared/timeclock/functions/lastPassInfoAgoValueHelper";

const ChangedCostDivision = ({ lastStamp, currentTime }: { lastStamp: ExistingStamp; currentTime: DateTime }) => {
    return <FormattedMessage {...StampContext.ChangedCostDivision} values={{
        ago: <FormattedRelativeTime value={getDaysAgoValue(lastStamp, currentTime)} unit="day" numeric="auto" />,
        timex: lastStamp.dateTime.toJSDate(),
        costDiv: lastStamp.costDivisionName
    }} />;
};

export const MissingTask = ({ stampCostDivisions }: { stampCostDivisions?: StampCostDivision[] }): React.ReactElement => {
    const costDiv = stampCostDivisions && stampCostDivisions.length === 1 ? stampCostDivisions[0].costDivisionName : null;

    return <FormattedMessage {...StampContext.MissingTask} values={{ costDiv }} />;
};

export const StampedIn = ({ lastStamp, currentTime }: { lastStamp: ExistingStamp; currentTime: DateTime }): React.ReactElement => {
    return <FormattedMessage {...StampContext.StampedIn} values={{
        ago: <FormattedRelativeTime value={getDaysAgoValue(lastStamp, currentTime)} unit="day" numeric="auto" />,
        direction: <FormattedMessage id={"Direction." + lastStamp.direction} />,
        timex: lastStamp.dateTime.toJSDate(),
        costDiv: lastStamp.costDivisionName
    }} />;
};

export const TaskReady = ({ task, currentTime }: { task: Task; currentTime: DateTime }): React.ReactElement => {
    const values = {
        isPast: task.start <= currentTime,
        start: task.start,
        costDiv: task.costDivisionName
    };
    return <FormattedMessage {...StampContext.TaskReady} values={values} />;
};

export const StampInfoText = ({ person }: { person: AuthenticatedPerson }): React.ReactElement => {

    const currentTime = DateTime.now();

    const stampedIn = person.lastStamp && StampDirection[person.lastStamp.direction] === StampDirection.In;
    const stampedOut = person.lastStamp && StampDirection[person.lastStamp.direction] === StampDirection.Out;

    const stampedInToday = stampedIn && person.lastStamp.dateTime.hasSame(DateTime.now(), "day");

    if (!person.stampInStatus && !person.stampOutStatus) {
        return <FormattedMessage {...Messages.OfflineStamp} />;
    } else if (person.lastStamp && StampDirection[person.lastStamp.direction] === StampDirection.Change) {
        return <ChangedCostDivision lastStamp={person.lastStamp} currentTime={currentTime} />;
    } else if ((!stampedInToday && !person.task) || (person.task && !person.task.date.hasSame(currentTime, "day") && stampedOut)) {
        return <MissingTask stampCostDivisions={person.stampCostDivisions} />;
    } else if (stampedIn) {
        return <StampedIn lastStamp={person.lastStamp} currentTime={currentTime} />;
    } else {
        return <TaskReady currentTime={DateTime.now()} task={person.task} />;
    }
};
